import { render, staticRenderFns } from "./DataTableItemFormattedNumber.vue?vue&type=template&id=9cd38df4&"
import script from "./DataTableItemFormattedNumber.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemFormattedNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports